import { GoToAccountSettingsCTA } from "./ctas";
export var ContactInfoIA = function ContactInfoIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return MANAGE_ACCOUNT_EMAIL(strictLocalize);
    },
    getDescription: function getDescription() {
      return [YOU_ARE_ABLE_TO_MANAGER_YOUR_ACCOUNT_EMAIL(strictLocalize)];
    }
  };
};
var getPrimaryCTA = function getPrimaryCTA(_context, strictLocalize) {
  return GoToAccountSettingsCTA(strictLocalize);
};
var MANAGE_ACCOUNT_EMAIL = function MANAGE_ACCOUNT_EMAIL(strictLocalize) {
  return strictLocalize({
    id: "kwHOHt",
    defaultMessage: "Manage account email"
  });
};
var YOU_ARE_ABLE_TO_MANAGER_YOUR_ACCOUNT_EMAIL = function YOU_ARE_ABLE_TO_MANAGER_YOUR_ACCOUNT_EMAIL(strictLocalize) {
  return strictLocalize({
    id: "egUlY+",
    defaultMessage: "You are able to manage your account email through the “Personal Info” section on the My Profile tab of your Account Settings page."
  });
};